/*******************************************************************************
 * @license (c)Copyright Since 2018, SOFTBANK Corp. All rights reserved.
 *
 *    機能概要   : SPA化によるページコントロール（描画作業、バリデーション作業）
 *    システム   : iTunesCDD
 ******************************************************************************/
'use strict';

var page = {
    showSelectScreen: function () {
        // 商品選択画面用データの作成
        ajaxComponent.request('/v1/products', 'GET', 'application/json', null)
            .done(function (data, textStatus, xhr) {
                // header から サーバー側のtokenをリフレッシュ
                utility.tokeReflush(xhr);
                // header から サーバー側の日付を取得
                var serverDate = new Date(xhr.getResponseHeader('Date'));
                var serverDateYear = serverDate.getFullYear();
                sessionStorage.setItem('itunesCdd_copyRightYear', serverDateYear);
                // 購入商品情報設定
                iTunesData.setProduct(data);
            });

        // 商品選択画面描画処理
        setScene("selectProductTemplate", iTunesData.product);
        utility.formEventControl();
        // チェックバリデーション処理
        selectSceneValidator();

        // environment.js.j2からGA処理を呼び出すか判定するための情報を環境変数より取得
        var gaString = utility.getEnviromentInfo(gaList, environment_id);
        // GA実行判定
        if (gaString) {
            // 商品選択画面用Google Analytics処理
            commonGA.itemSelectGA(iTunesData.product);
        }
    },

    // 内容確認画面表示情報設定
    showConfirmScreen: function () {
        setSelectData();
        if (!selectData.validCouponCodeFlag) return;
        // 内容確認画面描画処理
        setScene("confirmProductTemplate", selectData);
        // Gift規約チェック
        giftAgreementCheck();

        // environment.js.j2からGA処理を呼び出すか判定するための情報を環境変数より取得
        var gaString = utility.getEnviromentInfo(gaList, environment_id);
        // GA実行判定
        if (gaString) {
            // 申込内容確認画面用Google Analytics処理
            commonGA.requestContentsConfirmGA(iTunesData.product, selectData.couponFlag);
        }
    },

    // 内容確認画面の戻るボタン処理
    backToSelectScreen: function () {
        setScene("selectProductTemplate");
    },

    // 内容確認画面の支払いボタン処理
    goToPaymentScreen: function () {
        var radioLabel = ''; // 課金開始要求APIのリクエストパラメータで使用する文字列
        var sendAddressFrom = ''; // 購入履歴仮登録で使用する送り主メールアドレス
        var sendAddressTo = ''; // 購入履歴仮登録で使用する送り先メールアドレス
        var nameFrom = ''; // 購入履歴仮登録で使用する送り主の名前
        var nameTo = ''; // 購入履歴仮登録で使用する送り先の名前
        var message = ''; // 購入履歴仮登録で使用するメッセージ項目
        var privilegeCode = ''; // 購入履歴仮登録で使用する特典コード
        var variableFlag = false ; // バリアブル選択フラグ

        var selectedCard = $("#select-main input[type=radio]:checked");
        if (selectedCard.val() == "0") {
            radioLabel = "バリアブル";
            variableFlag = true;
        } else {
            radioLabel = selectedCard.val() + '円';
        }

        // セッションに渡すギフト情報判定
        if ($('#option-gift').prop('checked')) {
            sendAddressFrom = $('#sendFromAddress').val();
            sendAddressTo = $('#sendToAddress').val();
            nameFrom = $('#nameFrom').val();
            nameTo = $('#nameTo').val();
            message = $('#sendToMessage').val();
        }

        // 特典コード設定
        privilegeCode = iTunesData.product.privilege_code;
        if ($('#option-coupon').prop('checked')) {
            privilegeCode = $('#couponCode').val();
        }
        var requestData = {
            // 商品情報（金額、タイムセール情報など格納）
            privilege_code: privilegeCode,
            charge_amount: utility.removeComma(selectData.chargeAmount),
            pay_amount: utility.removeComma(selectData.payAmount),
            gift_flag: selectData.giftFlag,
            gift_sender_name: nameFrom,
            gift_sender_email: sendAddressFrom,
            gift_receiver_name: nameTo,
            gift_receiver_email: sendAddressTo,
            gift_message: message,
            purchase_contents_value: radioLabel,
            variable_flag: variableFlag
        }

        // 支払い画面に遷移
        ajaxComponent.request('/v1/purchases/request', 'POST', 'application/json',
                JSON.stringify(requestData))
            .done(function (data, textStatus, xhr) {
                // header から サーバー側のtokenをリフレッシュ
                utility.tokeReflush(xhr);
                window.location.href = data.redirect_url;
            });
    }
};